/**
 * Sync state machine for the offline punch queue (API-4379).
 *
 * Mirrors iOS `OfflinePunchingService.SyncState`: the `SyncState` union plus
 * small typed constructors for each state, so the engine (`SyncStateContext`)
 * and its consumers share one source of truth for the state shape. `synced` is
 * intentionally transient — the context resets it to `nothingToSync` after the
 * UI has had a chance to show it.
 */

export type SyncState =
    | { status: 'nothingToSync' }
    | { status: 'readyToSync'; count: number }
    | { status: 'syncing'; count: number }
    | { status: 'synced' }
    | { status: 'unavailable'; count: number | null };

export const nothingToSync = (): SyncState => ({ status: 'nothingToSync' });

export const readyToSync = (count: number): SyncState => ({
    status: 'readyToSync',
    count
});

export const syncing = (count: number): SyncState => ({
    status: 'syncing',
    count
});

export const synced = (): SyncState => ({ status: 'synced' });

export const unavailable = (count: number | null): SyncState => ({
    status: 'unavailable',
    count
});
